import { render, staticRenderFns } from "./DonationSearchForm.vue?vue&type=template&id=bbc13212&"
import script from "./DonationSearchForm.vue?vue&type=script&lang=js&"
export * from "./DonationSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports